import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { DropdownMenuComponent } from './dropdown-menu.component';
import { PortalModule } from '@angular/cdk/portal';
import { OverlayModule } from '@angular/cdk/overlay';
import { ButtonModule } from '@shared/button';

import { DropdownTriggerForDirective } from './dropdown-panel/dropdown-trigger-for.directive';

@NgModule({
  imports: [CommonModule, PortalModule, OverlayModule, ButtonModule],
  declarations: [DropdownMenuComponent, DropdownTriggerForDirective],
  exports: [DropdownMenuComponent, DropdownTriggerForDirective],
})
export class DropdownMenuModule {}
